import { clearPaymentErrorAction } from 'actions/clearPaymentErrorAction';
import { getPaymentStatusAction } from 'actions/index';
import { Loading } from 'components/shared/loading';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { PaymentIFrame } from '../../../shared/paymentIFrame';
import { HpMessageHandler } from 'actions/getPaymentStatusAction';

interface CardUpdatePortalProps {
  cardUpdateSuccessPage: JSX.Element;
  buttonText: string;
  subHeadingText: string;
  paymentMessageOverrides?: Partial<Record<string, HpMessageHandler>>;
}

export const CardUpdatePortal = ({
  cardUpdateSuccessPage,
  buttonText,
  subHeadingText,
  paymentMessageOverrides
}: CardUpdatePortalProps): JSX.Element => {
  const paymentGuid = useAppSelector((state) => state.payments.paymentGuid);
  const isBraintreeLoading = useAppSelector((state) => state.payments.isBraintreeLoading);
  const isPaymentSetupLoading = useAppSelector((state) => state.payments.isPaymentSetupLoading);
  const isPaymentSuccess = useAppSelector((state) => state.payments.isPaymentSuccess);

  const dispatch = useAppDispatch();

  const paymentMessageListener = (message: MessageEvent<any>): void => {
    dispatch(getPaymentStatusAction(message, paymentMessageOverrides));
  };

  useEffect(() => {
    window.removeEventListener('message', paymentMessageListener); // make sure we don't double up.
    window.addEventListener('message', paymentMessageListener);
    return () => {
      // Called when component unmounts
      dispatch(clearPaymentErrorAction());
    };
  }, []);

  if (isPaymentSuccess) {
    return cardUpdateSuccessPage;
  }

  if (isPaymentSetupLoading) {
    return <Loading heading="Loading payment page" text="Please wait while we load the payment page" />;
  }

  return (
    <div>
      {isBraintreeLoading && (
        <Loading heading="Loading payment page" text="Please wait while we load the payment page" />
      )}
      {/* Render iFrame while loading  */}
      <PaymentIFrame
        id={0}
        paymentGuid={paymentGuid}
        isBraintreeLoading={isBraintreeLoading}
        buttonText={buttonText}
        showPaymentHeader={false}
        subHeadingText={subHeadingText}
      />
    </div>
  );
};
